import { Component, OnInit } from '@angular/core';
import { CustomContainerInterFace } from '../../custom-container/custom-container-interface';
import { OfbizForm, FieldSet, OfbizField, OfbizFormsService, OfbizFormField, FormUtilityService } from '@urbannex/ofbiz-forms';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'ubs-store-edit-container',
  templateUrl: './store-edit-container.component.html',
  styleUrls: ['./store-edit-container.component.scss']
})
export class StoreEditContainerComponent implements OnInit, CustomContainerInterFace {

  constructor(
    private fb: FormBuilder,
    private ofbizFormsService: OfbizFormsService,
    private formUtilityService: FormUtilityService) { }


  selectedValue: any;
  ofbizForm: OfbizForm;
  fieldSets: FieldSet[];
  fields: OfbizField[];
  data: any;
  editStoreForm: FormGroup;

  formFields: OfbizFormField<any>[];
  hiddenFields: OfbizFormField<any>[];
  shownFields: OfbizFormField<any>[];

  isLoaded: boolean = false;

  ngOnInit(): void {
    console.log({ CustomData: this.data })
    this.fields = this.data.form.fields ? this.data.form.fields : [];
    this.fieldSets = this.data.form.fieldSets ? this.data.form.fieldSets : [];
    this.ofbizForm = this.data.form;
    setTimeout(() => {                           // <<<---using ()=> syntax
      this.createForm(this.ofbizForm, this.fieldSets);
    }, 300);
  }

  createForm(ofbizForm: OfbizForm, fieldSets?: FieldSet[]): void {
    // throw new Error('Method not implemented.');
    this.editStoreForm = this.fb.group(this.getFormArrays(fieldSets));
    this.ofbizFormsService.getFormFields(ofbizForm["fields"])
      .subscribe((formFields: OfbizFormField<any>[]) => {
        this.formFields = formFields;
        console.log({ AddingControlsFields: this.formFields })
        if (formFields.length > 0) {
          /* if(this.isLookup){
            this.addOptionalFields(this.formFields);
          } */
          this.hiddenFields = this.formFields.filter(field => field.controlType == 'hidden' || field.controlType == 'HIDDEN');
          this.shownFields = this.formFields.filter(field => field.controlType != 'hidden' && field.controlType != 'HIDDEN');
          Object.keys(this.editStoreForm.controls).forEach(key => {
            console.log({ AddingControlsFor: key })
            const fieldSetFormFields: OfbizFormField<any>[] = this.getFieldSetFormFields(fieldSets, key)
            if (fieldSetFormFields != undefined) {

              // console.log(fieldSetFormFields)
              fieldSetFormFields.forEach(fieldSetFormField => {
                console.log(fieldSetFormField)
                if (fieldSetFormField.name) {
                  console.log({ AddingControls: fieldSetFormField.name, Value: fieldSetFormField.value })
                  this.editStoreForm.controls[key]["controls"][fieldSetFormField.name] = new FormControl(fieldSetFormField.value || '')
                }
              })
            }


          })
          console.log(this.editStoreForm);
          this.isLoaded = true;
        }
      })
    console.log("Form Created: ", this.editStoreForm);
  }

  getFormArrays(fieldSets: FieldSet[]) {
    const group = {};
    fieldSets.forEach(fieldSet => {
      group[fieldSet.fieldSetName] = new FormArray([]);
    })
    return group
  }

  getFieldSetFormFields(fieldSets: FieldSet[], key: string): OfbizFormField<any>[] {
    console.log({ FormFields: this.formFields });
    const fieldSetFormFields = [];
    const fieldSet: FieldSet = fieldSets.find(fieldSet => fieldSet.fieldSetName == key);
    if (fieldSet) {
      fieldSet.fields.forEach(fieldSetField => {
        const selectedFormField = this.formFields.find(formField => formField.name == fieldSetField);
        if (selectedFormField != undefined) {
          fieldSetFormFields.push(selectedFormField)
        }

      });
    }

    return fieldSetFormFields
  }
  // Add a method to handle form submission and log the complete form value
  onSubmit(): void {
    console.log('Complete form value on submit:', this.editStoreForm.value);
    // Check if form is nested
    if (this.formUtilityService.isNestedFormValue(this.editStoreForm.value)) {
      console.log('Form has nested structure');

      // Get all field names
      const fieldNames = this.formUtilityService.getFormFieldNames(this.editStoreForm.value);
      console.log('All field names:', fieldNames);

      // Create FormData with custom options
      // Use dot notation flattening to match backend expectations like 'Classification.productId'
      /* const formData = this.formUtilityService.createFormDataFromValue(this.editStoreForm.value, {
        separator: '.', // Use dot separator (this is the default)
        includeNullValues: false
      }); */
      /* const formData = this.formUtilityService.createFormDataFromValue(
        this.editStoreForm.value,
        {
          separator: '_',
          prefix: 'form',
          includeNullValues: false
        }
      ); */
      const formData = this.formUtilityService.createFormDataFromValue(this.editStoreForm.value, {
        isFieldsetForm: true,        // Recognize fieldset structure
        preserveFieldsetNames: false, // Keep 'Classification.' prefix
        separator: '.',               // Use dot separator (default)
        useOriginalFieldNamesOnly: true // Use original field names only
      });
      formData.forEach((value, key) => {
        console.log(`${key}:`, value);
      });
      /* this.httpService.post('/api/submit', formData).subscribe(response => {
        console.log('Submitted successfully:', response);
      }); */
    }
    console.log('Form valid:', this.editStoreForm.valid);
  }

}
